import * as R from 'ramda';
import React from 'react';
import { css } from '@emotion/react';
import {
	Button,
	Typography,
	CircularProgress,
	Paper,
	Box,
	Divider
} from '@mui/material';
import { useQuery } from '@cd/react-query';
import { postJSONPS, convertDateToLocalTime } from '@cd/utils';
import { either, indexMap } from '@cd/utils';
import { useStore } from './store';
import LegalList from './LegalList';
import { useHistory } from 'react-router-dom';
import { flashStyle } from '../main/genericEmotionStyles';

const wrapStyle = css({
	display: 'flex',
	flexDirection: 'column',
	padding: '8px',
	marginTop: '8px'
});

export function useGetContractList() {
	const url = `/get/legal/list`;
	const { dispatch } = useStore();

	return useQuery(['legalListGroup'], () =>
		postJSONPS('GET', url).then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}

const ButtonCmp = ({ contractID, signed }) => {
	const history = useHistory();
	function onClick() {
		setTimeout(() => {
			history.push(`/account/legal/list/${contractID}`);
		}, 500);
	}

	return (
		<Button
			onClick={onClick}
			variant="outlined"
			sx={{ display: 'flex', flexDirection: 'column' }}>
			<Typography variant="body">
				{signed ? 'VIEW' : 'REQUIRES ACCEPTANCE'}
			</Typography>
			<Typography css={flashStyle} variant="caption" color="orange">
				Click to view agreement
			</Typography>
		</Button>
	);
};

const oneLineStyle = css({
	display: 'flex',
	'&>*:first-child': { marginRight: '8px' }
});

const LegalListGroup = ({ contractID }) => {
	const { isFetching, data = [] } = useGetContractList();

	if (isFetching) return <CircularProgress />;

	const contractGroup = R.compose(R.toPairs, R.groupBy)(
		R.prop('contract_id'),
		data
	);

	return (
        <Paper css={wrapStyle}>
            {indexMap(([contractID, dataList], index) => {
				const { active_date, signed_date, hash, contract_name } =
					dataList[0];

				return (
                    <Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							p: 2
						}}
						elevation={3}>
                        <Box
							sx={{
								display: 'flex',
								flexDirection: 'column'
							}}>
							<Box sx={oneLineStyle}>
								<Typography>Title:</Typography>
								<Typography color="primary">
									{R.toUpper(contract_name)}
								</Typography>
							</Box>
							<Box sx={oneLineStyle}>
								<Typography>ID:</Typography>
								<Typography color="primary">{hash}</Typography>
							</Box>
						</Box>
                        <Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between'
							}}>
							<Box sx>
								<Typography>Start Date:</Typography>
								<Typography color="primary">
									{convertDateToLocalTime(
										'MM/dd/yyyy',
										active_date
									)}
								</Typography>
							</Box>
							<Box sx>
								<Typography>Accepted on:</Typography>
								<Typography color="primary">
									{(signed_date &&
										convertDateToLocalTime(
											'MM/dd/yyyy',
											signed_date
										)) ||
										'Not Accepted'}
								</Typography>
							</Box>
						</Box>
                        <Divider sx={{ mt: 2, mb: 2 }} />
                        <Box
							sx={{
								display: 'flex',
								justifyContent: 'flex-end'
							}}>
							<ButtonCmp
								contractID={contractID}
								signed={signed_date}
							/>
						</Box>
                        <Box component="div">List of Services and Charges</Box>
                        <LegalList
							key={contractID}
							listStyle={css({ flex: 1 })}
							noTotalRow={true}
							data={dataList}
						/>
                    </Box>
                );
			}, contractGroup)}
        </Paper>
    );
};
export default LegalListGroup;
